<template>
  <section id="zusammenfassung">
    <description>Ihre Konfiguration in der Kurzübersicht. Sichern Sie sich jetzt Ihr kostenloses und unverbindliches Angebot mit allen Details.</description>
    <section class="config">
      <Summary :configuration="configuration" :total="total" />
    </section>
    <inclusive-footer />
    <how-to />
    <made />
    <angebot-banner heading="Angebot anfordern" :total="$root.totalOutput" :monthlyPaymentSelected="$root.monthlyPaymentSelected" />
  </section>
</template>

<script>
import Summary from '@/components/Summary.vue'
import Description from '@/components/Description.vue'
import InclusiveFooter from '@/components/InclusiveFooter.vue'
import AngebotBanner from '@/components/AngebotBanner.vue'
import HowTo from '@/components/HowTo.vue'
import Made from '@/components/Made.vue'
export default {
  name: 'zusammenfassung',
  components: {
    Description,
    Summary,
    InclusiveFooter,
    AngebotBanner,
    Made,
    HowTo
  },
  computed: {
    configuration: function () {
      return {
        configuration: this.$root.items
      }
    },
    total: function () {
      return this.$root.total
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
#zusammenfassung {
  padding: 80px 0 110px 0;
  .config {
    margin: 30px 15px 0 15px;
  }
}
@media (min-width: 580px) {
  #zusammenfassung {
    padding: 80px 0 80px 0; // 40px + 80px angebotbanner height
  }
}
@media(min-width:767px) {
  #zusammenfassung {
    padding: 100px 0 80px 0;
    .config {
      margin: 40px 40px 0 40px;
    }
  }
}
@media (max-height: 320px) and (max-width: 579px) {
  #zusammenfassung {
    padding: 80px 0 60px 0; // 40px + 60px angebotbanner height
  }
}
</style>
